import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_modern_farmhouse: FaireThemeEntity = {
  token: "discovery_theme_modern-farmhouse",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Modern Farmhouse",
  description: "Rustic meets refined for country-chic spaces",
  bgColor: "#E8E0D0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
